






























































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Brand, Model, VehicleType, VehicleTypeOriginRange, vehicleTypes} from '@/modules/neovehicle/models';
import {ClassificationModelFilter} from '@/modules/neovehicle/models/filters';
import debounce from 'lodash/debounce';
import {v4 as uuidv4} from 'uuid';
import { CountryEnum } from '@/models/Enums';
import { SocialClass } from '@/modules/neovehicle/models/socialClass';

@Component
export default class extends Vue {
  @Prop({type: Array})
  public data: Model[];

  @Prop({type: Boolean})
  public loading: boolean;

  @Prop({type: Boolean})
  public buttonDisabled: boolean;

  @Prop({type: Object})
  public filter: ClassificationModelFilter;

  @Prop({type: Array})
  public vehicleTypeOriginsRange: VehicleTypeOriginRange[];

  @Prop({type: Array})
  public brands: Brand[];

  @Prop({type: Array})
  public vehicleTypesSearch: VehicleType[];

  @Prop({type: Object})
  public country: CountryEnum;

  @Prop({type: Array})
  public socialClasses: SocialClass[];

  public headers: any = [];
  public vehicleTypes = vehicleTypes;
  public vehicleTypeOriginRangeType = VehicleTypeOriginRange;
  public checkboxSelected: Model[] = [];
  public checkboxAll: boolean = false;
  public uuidv4 = uuidv4;

  public pagination = {
    sortBy: 'name',
    descending: false,
  };

  public headersMap = [
    {text: '', value: 'checkbox', sortable: false, width: 10, checkbox: true},
    {text: 'Código', value: 'id', sortable: true, width: 100},
    {text: 'Código Origem', value: 'idorigin', sortable: true, width: 150},
    {text: 'Descrição do Modelo', value: 'name', sortable: true},
    {text: 'Tipo de Veículo (Fonte)', value: 'vehicletypeorigin.name', width: 210},
    {text: 'Tipo de Veículo', value: 'id', isClassified: true, width: 150},
    {text: 'Bandeira', value: 'brand.name', isClassified: true, width: 120},
    {text: 'Versão/Família', value: 'familyversion.name', isClassified: true, width: 150},
    {text: 'Família', value: 'familyversion.family.name', isClassified: true, width: 100},
    {text: 'Grupo/Família', value: 'familyversion.family.familygroup.name', isClassified: true, width: 150},
    {text: 'Tags', value: 'familyversion.family.tagsname', isClassified: true, width: 80},
    {text: 'Classe Social', value: 'familyversion.family.socialclassname', isClassified: true, width: 80},
    {text: '', value: 'id', sortable: false, noText: false},
  ];

  public get isLatam() {
    return this.country !== CountryEnum.Brasil;
  }

  public get showHeaders() {
    const headers = this.headers.filter(
      (x: any) =>
        (x.isClassified === this.filter.isClassified ||
        typeof x.isClassified === 'undefined'),
    );

    return this.isLatam
      ? headers.filter((x: any) => x.text !== 'Tags')
      : headers.filter((x: any) => x.text !== 'Classe Social');
  }

  public created() {
    this.headers = this.headersMap.slice();
  }

  public resetSelect() {
    this.checkboxSelected = [];
    this.checkboxAll = false;
  }

  @Watch('data')
  public watchData() {
    this.headers = this.headersMap.slice();
  }

  @Watch('checkboxSelected')
  public watchCheckboxSelected() {
    this.$emit('select', this.checkboxSelected);
  }

  public changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }

  public handleForm(edit: boolean, model: Model) {
    this.$emit('click-form', edit, model);
  }

  public handleSelectForm(edit: boolean) {
    this.$emit('click-select-form', edit);
  }

  public handleSelectMove() {
    this.$emit('click-select-move');
  }

  public handlePagination() {
    this.checkboxAll = false;
  }

  public handleCheck(checked: boolean) {
    this.$nextTick(() => {
      [...document.querySelectorAll('input[data-id]')]
        .map((el: any) => Number(el.dataset.id))
        .forEach((id: number) => {
          if (checked) {
            const models = this.data.filter((m: Model) => m.id === id);

            if (models.length) {
              this.checkboxSelected.push(models[0]);
            }
          } else {
            this.checkboxSelected = this.checkboxSelected.filter((m: Model) => m.id !== id);
          }
        });
    });
  }

  public get handleSearchModel() {
    return debounce(() => {
      this.$emit('search');
    }, 1000);
  }
}
